import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import ActiveHelper from '../../../components/common/activeHelper';
import { firestore } from '../../../helpers/Firebase';
import { createNotification, deviceWidth } from '../../../helpers/Utils';

const FeaturedProviders = () => {
  const { activeItem } = useSelector(state => state.activeItem);
  const { provider } = useSelector(state => state.providers);
  const search = useSelector(state => state.settings.search) || '';

  const elements = useMemo(() => {

    return [{
      key: 'generalInfo',
      hideTitle: true,
      data: [

        {
          key: 'provider',
          title: 'Provider', width: '12', type: 'select',
          data: Object.values(provider || {}).map(rec => ({ ...rec, name: rec.name, key: rec.key, id: rec.key })),
          hide: !activeItem?.general?.addNew
        },
        {
          key: 'endDate',
          title: 'End date and time',
          parent: 'featured',
          width: '12',
          type: 'date',
        },

      ]
    }];
  }, [activeItem?.general?.addNew, provider]);

  const customSubmitFunction = (item) => {
    if (activeItem?.general?.addNew) {
      firestore().collection('service_provider').doc(activeItem?.general?.provider).update({
        featured: {
          ...item.featured,
          index: Object.values(provider || {}).filter(rec => rec.featured).length,
        },
        updated: Date.now(),
      }).then(() => {

        createNotification('success', 'Provider updated successfully')
      })
    } else {
      firestore().collection('service_provider').doc(item.id || item.key).update({
        featured: item.featured,
        updated: Date.now(),
      }).then(() => {
        createNotification('success', 'Provider updated successfully')
      })
    }
  }
  const customDeleteFunction = (item) => {
    firestore().collection('service_provider').doc(item.id || item.key).update({
      featured: false,
      updated: Date.now(),
    }).then(() => {
      createNotification('success', 'Provider removed successfully')
    })
  }

  // Filter data based on search term
  const filteredData = useMemo(() => {
    const featuredProviders = Object.values(provider || {})?.filter(rec => rec.featured)?.sort((a, b) => a.featured.index - b.featured.index) || [];
    
    if (!search || !search.trim()) {
      return featuredProviders;
    }

    const searchLower = search.toLowerCase().trim();
    return featuredProviders.filter(provider => {
      const nameMatch = (provider?.name || '')?.toLowerCase().includes(searchLower);
      const emailMatch = (provider?.email || '')?.toLowerCase().includes(searchLower);
      const numberMatch = (provider?.number || '')?.toLowerCase().includes(searchLower);
      return nameMatch || emailMatch || numberMatch;
    });
  }, [provider, search]);

  const tableColumns = useMemo(() => {
    return [
      { Header: "", accessor: "pictures", width: deviceWidth() === 'desktop' ? 150 : 80, type: 'img' },
      { Header: "Name", accessor: "name", width: 250, type: 'label' },
      { Header: "Email", accessor: "email", width: 150, type: 'label' },
      { Header: "Number", accessor: "number", width: 150, type: 'label' },
      { Header: 'End Date', accessor: 'featured.endDate', width: 150, type: 'date', show: deviceWidth() === 'desktop' },
      { Header: 'Index', accessor: 'featured.index', type: 'label', },
    ];
  }, []);

  return (
    <div>
      <ActiveHelper
        data={filteredData || []}
        title="Featured Providers"
        selected='service_provider'
        elements={elements}
        tableColumns={tableColumns}
        enableSorting={true}
        defaultSorting="featured.index"
        sortDirection={'asc'}
        renderAsModal={true}
        modalSize='lg'
        modalBackdrop='static'
        customDeleteTitle='Remove'
        customDeleteFunction={customDeleteFunction}
        customSubmitFunction={customSubmitFunction}
        showCreateButton={true}
      />
    </div>
  );
};


export default FeaturedProviders;
